var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentPageName === 'time-rollup')?_c('report-container',{attrs:{"actions":_vm.actions},scopedSlots:_vm._u([{key:"report-modals",fn:function(){return [_c('time-modal')]},proxy:true}],null,false,2017228992)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }